import { storyblokEditable } from "@storyblok/react";
import { ArrowRight } from "react-feather";

// Link resolver
const resolveStoryblokLink = (link) => {
  if (!link) return "#";

  // Internal story
  if (link.linktype === "story") {
    const slug = link.cached_url || link.story?.full_slug;
    return slug ? `/${slug}` : "#";
  }

  // Assets
  if (link.linktype === "asset") {
    return link.url || "#";
  }

  // URLs
  return link.url || link.cached_url || "#";
};

const LargeTextCard = ({ blok }) => {
  const href = resolveStoryblokLink(blok.link);

  return (
    <div
      {...storyblokEditable(blok)}
      className="flex flex-col bg-white text-black rounded-lg p-6 shadow-md hover:shadow-lg transition h-[405px]"
    >
      {/* Icon + Category */}
      <div className="flex items-center gap-2 mb-3">
        {blok.icon?.filename && (
          <img src={blok.icon.filename} alt="" className="w-5 h-5" />
        )}

        <p className="text-sm font-semibold uppercase tracking-wide text-black-600">
          {blok.resource_type}
        </p>
      </div>

      {/* Title */}
      <h3 className="text-lg font-medium mb-6">{blok.title}</h3>

      {/* Cta */}
      <a
        href={href}
        className="mt-auto flex items-center gap-2 text-black-700 font-semibold"
      >
        {blok.cta_text || ""} <ArrowRight size={16} />
      </a>
    </div>
  );
};

export default LargeTextCard;
